import { render, staticRenderFns } from "./rfm.vue?vue&type=template&id=4a54dd65&scoped=true&"
import script from "./rfm.vue?vue&type=script&lang=js&"
export * from "./rfm.vue?vue&type=script&lang=js&"
import style0 from "./rfm.vue?vue&type=style&index=0&id=4a54dd65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54dd65",
  null
  
)

export default component.exports